import React from 'react';
import { RenderAppropriate } from '../internals/RenderAppropriate';
import { FlexStyle } from '../styles/layout/flex.styles';

export interface FlexProps {
    children?: React.ReactNode;
    component?: React.ElementType;
    [key: string]: any;
}

export const Flex: React.FC<FlexProps> & { Style: typeof FlexStyle } = ({ children, component: Component, ...rest }) =>
    RenderAppropriate(FlexStyle, rest, children, Component);

Flex.Style = FlexStyle;
